/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PlanTab {
  RECOMMENDED = 'RECOMMENDED',
  ALL_PLANS = 'ALL_PLANS',
  SAVED = 'SAVED',
}
